import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { BsModalService } from 'ngx-bootstrap';

import { ProjectsService } from 'app/_services/projects.service';
import { ComparePageAnalyticService } from './compare-page-analytic.service';


const moment = require('moment');
@Component({
  selector: 'app-compare-page-analytic-manager',
  templateUrl: './compare-page-analytic.component.html',
  styleUrls: ['./compare-page-analytic.component.scss']
})
export class ComparePageAnalyticManagerComponent implements OnInit {


  brandDropDownSettings: any;
  brandSelected = [];
  brandSelectedFilter = [];
  brands = [];
  notSpam = true;
  notSpam2 = false;
  reportName = "";
  dataReport: Object;

  projectDropDownSettings: any;
  projectSelected = [];
  projectSelectedFilter = [];
  projects = [];

  typeReport = 'day';
  typeReportFilter = 'day';

  typeAction = 'create';


  dtOptions: DataTables.Settings = {};
  dataList = [];
  dataTableShow = false;
  currentConfigItem: object;
  modalRef: BsModalRef;
  modalRef2: BsModalRef;
  daterange: any = {
    start: moment().subtract(1, "days").startOf('day'),
    end: moment().subtract(1, "days").endOf('day')
  };
  daterangeFilter: any = {
    start: moment().subtract(7, "days").startOf('day'),
    end: moment().subtract(1, "days").endOf('day')
  };
  dateRangeRecommand: any = {
    start: moment().subtract(1, "days").startOf('day'),
    end: moment().subtract(1, "days").endOf('day')
  };


  options = {
    locale: { format: 'DD/MM/YYYY' },
    timePicker: false,
    timePicker24Hour: true,
    timePickerSeconds: true,
    alwaysShowCalendars: false,
    maxDate: moment().subtract(1, "days").endOf('day').toDate(),
    startDate: this.daterange.start,
    endDate: this.daterange.end
  };

  optionsFilter = {
    locale: { format: 'DD/MM/YYYY' },
    timePicker: false,
    timePicker24Hour: true,
    timePickerSeconds: true,
    alwaysShowCalendars: false,
    maxDate: moment().endOf('day').toDate(),
    startDate: this.daterangeFilter.start,
    endDate: this.daterangeFilter.end
  };

  optionsRecommand = {
    locale: { format: 'DD/MM/YYYY' },
    timePicker: false,
    timePicker24Hour: true,
    timePickerSeconds: true,
    alwaysShowCalendars: false,
    maxDate: moment().subtract(1, "days").endOf('day').toDate(),
    startDate: this.dateRangeRecommand.start,
    endDate: this.dateRangeRecommand.end
  };


  listPosts = [];







  currentSourceEdit = 'facebook';

  constructor(
    private projectsService: ProjectsService,
    private toastrService: ToastrService,
    private comparePageAnalytic: ComparePageAnalyticService,
    private modalService: BsModalService
  ) {
    this.getDataFromServer();
    this.getProject();
    this.getReportManager();
  }

  ngOnInit(): void {
    this.brandDropDownSettings = {
      singleSelection: false,
      text: 'Chọn thương hiệu',
      selectAllText: 'Chọn tất cả',
      unSelectAllText: 'Bỏ chọn tất cả',
      enableSearchFilter: false,
      badgeShowLimit: 2,
    };
    this.projectDropDownSettings = {
      singleSelection: true,
      text: 'Chọn chủ đề',
      selectAllText: 'Chọn tất cả',
      unSelectAllText: 'Bỏ chọn tất cả',
      enableSearchFilter: false,
      badgeShowLimit: 2,
    };
    this.dtOptions = {
      pagingType: 'full_numbers',
      ordering: true,
      searching: true,
      paging: true,
      language: {
        infoEmpty: 'Không tìm thấy dữ liệu',
        infoFiltered: '(trong _MAX_ )',
        info: 'Hiển thị _START_ - _END_ trên _TOTAL_',
        lengthMenu: 'Hiển thị _MENU_ ',
        search: 'Tìm kiếm',
        zeroRecords: 'Không có dữ liệu !',
        paginate: {
          first: '<<',
          previous: '<',
          next: '>',
          last: '>>',
        }
      },
      columnDefs: [
        { 'targets': [0, 1, 2, 3, 4, 5], 'searchable': true }
      ]
    };
  };

  selectedDate(value: any, datepicker?: any) {
    datepicker.start = value.start.startOf('day');
    datepicker.end = value.end.endOf('day');
    this.daterange.start = value.start;
    this.daterange.end = value.end;

    this.options.startDate = this.daterange.start;
    this.options.endDate = this.daterange.end;
  }

  selectedDateFilter(value: any, datepicker?: any) {
    datepicker.start = value.start.startOf('day');
    datepicker.end = value.end.endOf('day');
    this.daterangeFilter.start = value.start;
    this.daterangeFilter.end = value.end;
  }

  showPreviewReport(item, modalRef) {
    this.typeAction = 'view';
    this.dataReport = {};
    this.dataReport = JSON.parse(JSON.stringify(item));
    this.modalRef2 = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'custom-modal'
    });
  }

  showCreateReport(modalRef) {
    this.typeAction = 'create';
    this.dataReport = {};
    this.modalRef2 = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'custom-modal'
    });
  }

  getProject() {
    this.projectsService.index().subscribe(response => {
      if (response.success) {
        response.data.projects.forEach(element => {
          let projectItem = {
            id: element._id,
            itemName: element.name,
            value: element.name
          };
          this.projects.push(projectItem);
        });
      }
    });

  }

  getDataFromServer() {
    this.dataTableShow = false;
    this.comparePageAnalytic.getAll().subscribe(res => {
      if (res.success) {
        res.data.forEach(element => {
          let obj = {
            id: element._id,
            itemName: element.name,
            value: element.name
          };
          this.brands.push(obj);
        });
      } else {
        this.toastrService.error('Lỗi hệ thống, Vui lòng liên hệ admin', ' Thông báo')
      }
    });
  }

  getReportManager() {
    let filter = {
      gte: this.daterangeFilter.start.valueOf(),
      lte: this.daterangeFilter.end.valueOf(),
      projects: this.projectSelectedFilter,
      brands: this.brandSelectedFilter,
      typeReport: this.typeReportFilter,
      report_code: ["BCSSHTBD"]
    };
    this.dataTableShow = false;
    this.comparePageAnalytic.getAllReportManager(filter).subscribe(response => {
      this.dataTableShow = true;
      this.dataList = response.data;
    });
  }


  clickReport() {
    if (this.brandSelected.length > 3) {
      this.toastrService.warning("Vui lòng chọn tối đa 3 thương hiệu", "Thông báo!");
      return;
    }
    if (this.brandSelected.length == 0) {
      this.toastrService.warning("Vui lòng chọn thương hiệu", "Thông báo!");
      return;
    }
    this.dataReport = {};
    // let timeRange = Math.ceil((this.daterange.end.valueOf() - this.daterange.start.valueOf()) / (24 * 60 * 60 * 1000));
    // if (timeRange > 60) {
    //   this.toastrService.warning("Khoảng thời gian chọn không được quá 60 ngày!", "Thông báo!");
    //   return;
    // }

    let filter = {
      gte: this.daterange.start.valueOf(),
      lte: this.daterange.end.valueOf(),
      projects: this.projectSelected,
      brands: this.brandSelected,
      type: this.typeReport,
      notSpam : this.notSpam2
    };
    this.comparePageAnalytic.getReport({ filter: filter }).subscribe(response => {
      let data = response.data;
      if (data) {
        let brandLists = data.brandLists;
        let aggregations = data.aggregations;
        if(aggregations) {
          for (var i = 0; i < brandLists.length; i++) {
    
            let dataBrand = aggregations[brandLists[i].name];
            brandLists[i]["linkCount"] = dataBrand.link.doc_count;
            brandLists[i]["linkInteractiveCount"] = dataBrand.link.interactive.value;
  
            brandLists[i]["videoCount"] = dataBrand.video.doc_count;
            brandLists[i]["videoInteractiveCount"] = dataBrand.video.interactive.value;
  
            brandLists[i]["photoCount"] = dataBrand.photo.doc_count;
            brandLists[i]["photoInteractiveCount"] = dataBrand.photo.interactive.value;
       
        }



        this.dataReport = {
          report_desc: "Báo cáo so sánh hình thức bài đăng trên fanpage",
          report_type: this.typeReport,
          report_name: "Báo cáo so sánh hình thức bài đăng trên fanpage " + this.daterange.start.format('DD/MM/YYYY') + " đến ngày " + this.daterange.end.format('DD/MM/YYYY'),
          report_project: this.projectSelected,
          report_brand: this.brandSelected,
          report_start_date: new Date(this.daterange.start.valueOf()),
          report_end_date: new Date(this.daterange.end.valueOf()),
          report_code: "BCSSHTBD", // báo cáo so sánh hình thức bài đăng
          data: brandLists
        }
        } else {
          this.toastrService.warning("Thương hiệu chọn chưa có fanpageId","Thông báo")
        }
       
      }
    });
    // console.log(filter);
  }
  clickSave() {
    if (this.dataReport) {
      if (this.reportName == "") {
        this.toastrService.warning("Bạn phải nhập tiêu đề cho báo cáo!", "Thông báo!");
        return;
      }
      this.dataReport["report_title"] = this.reportName.trim();
      this.comparePageAnalytic.createReportManager(this.dataReport).subscribe(response => {
        if (response.success) {
          this.toastrService.success("Đã tạo báo cáo thành công!", "Thông báo!");
          this.getReportManager();
        } else {
          this.toastrService.warning(response.msg, "Thông báo!");
        }
        this.closeModal();
      });
    } else {
      this.toastrService.warning("Không có dữ liệu báo cáo cần cập nhật!", "Thông báo!");
    }
  }
  clickDeleteItem(item, modalRef) {
    this.modalRef = this.modalService.show(modalRef);
    this.currentConfigItem = JSON.parse(JSON.stringify(item));
  }
  clickSaveConfirm(modalRef) {
    if (!this.dataReport) {
      this.toastrService.warning("Không có dữ liệu báo cáo cần cập nhật!", "Thông báo!");
      return;
    }
    this.reportName = "";
    this.modalRef = this.modalService.show(modalRef);
  }

  deleteReport() {
    this.comparePageAnalytic.deleteReport(this.currentConfigItem['_id']).subscribe(res => {
      if (res.success) {
        this.getReportManager();
        this.toastrService.success('Xóa báo cáo thành công !', 'Thông báo');
        this.closeModal();
      } else {
        this.toastrService.error('Xóa báo cáo thất bại !', 'Thông báo');
      }
    });
  }
  closeModal() {
    this.modalRef.hide();
    this.modalRef2.hide();
  }

  async savePosts() {

    let tempDataReport = JSON.parse(JSON.stringify(this.dataReport));
    this.dataReport = {};
    this.dataReport = tempDataReport;

    this.modalRef.hide();
  }

  clickEditReportItem(item, modalRef) {
    this.currentConfigItem = JSON.parse(JSON.stringify(item));
    this.currentSourceEdit = 'facebook';

    this.modalRef = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'modal-lg'
    });
  }


  saveEditPost() {
    this.comparePageAnalytic.updateReport(this.currentConfigItem['_id'], this.currentConfigItem['data']).subscribe(res => {
      if (res.success) {
        this.toastrService.success('Update thành công', 'Thông báo');
        this.modalRef.hide();
        this.getReportManager();
        this.dataReport = null;
        this.dataReport = this.currentConfigItem;
      }
    });
  }


  onItemSelect(item: any) {
  }
  OnItemDeSelect(item: any) {
  }

  onSelectAll(items: any) {
  }

  onDeSelectAll(items: any) {
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-module/compare-page-analytic/compare-page-analytic.component.ts